module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [(_vm.allNotifications.length > 0) ? _vm._c('div', {
    staticClass: "notification-panel"
  }, [_vm._c('div', {
    staticClass: "container-fluid xs-pt-0"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-md-12"
  }, [_vm._c('div', {
    staticClass: "xs-pl-10 xs-pr-10"
  }, [_vm._c('h3', [_vm._v("Notifications")]), _vm._v(" "), _vm._c('NotificationList', {
    attrs: {
      "show-delete": true
    }
  })], 1)])])])]) : _vm._e(), _vm._v(" "), _vm._c('PageHeader', {
    attrs: {
      "title": "Subject Shelf",
      "subtitle": "Organize your study material"
    }
  }, [(_vm.showImport) ? _vm._c('router-link', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "to": {
        name: 'importer'
      }
    },
    slot: "top"
  }, [_vm._c('i', {
    staticClass: "icon mdi mdi-cloud-upload"
  }), _vm._v("  Import Notes\n    ")]) : _vm._e()], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "main-content container-fluid xs-pt-0"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.subjects || !_vm.subjects.length) ? _vm._c('Panel', [_vm._c('PanelBody', [(!_vm.subjects) ? _vm._c('p', [_vm._c('LoadingIndicator')], 1) : (!_vm.subjects.length) ? _vm._c('div', [(_vm.showImport) ? _vm._c('div', [_vm._c('h3', [_vm._v("Welcome to CLEX")]), _vm._v("\n                This is where all your subjects and lecture notes will display."), _vm._c('br'), _vm._c('br'), _vm._v(" "), _vm._c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "to": {
        name: 'importer'
      }
    }
  }, [_vm._v("Import your first Lecture Note")])], 1) : _vm._e(), _vm._v(" "), (!_vm.showImport) ? _vm._c('div', [_vm._c('h3', [_vm._v("Welcome to CLEX")]), _vm._v("\n                Your course materials will display here once your school has uploaded study notes.\n              ")]) : _vm._e()]) : _vm._e()])], 1) : _vm._c('div', _vm._l((_vm.subjects), function(subject) {
    return _vm._c('div', [_vm._c('SubjectShelfSubject', {
      attrs: {
        "subject": subject
      }
    })], 1)
  }))], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b1b781d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/subject-shelf/SubjectShelf.vue
// module id = 662
// module chunks = 1